import { http } from './client'
import type { ExecutiveMetrics } from '../types/api'

export async function getExecutiveReport(
  scanId: string,
  teamSize: number = 5,
  generateNarrative: boolean = true,
  forceRegenerate: boolean = false,
): Promise<ExecutiveMetrics> {
  const qs = new URLSearchParams({
    team_size: String(teamSize),
    generate_narrative: String(generateNarrative),
    force_regenerate: String(forceRegenerate),
  })
  return http.get(`/api/v1/scans/${scanId}/executive-report?${qs}`)
}
